var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParticipateSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.2354 0C27.7845 0 26.5039 0.561199 25.5 1.62981C24.4961 0.561199 23.2155 0 21.7646 0C18.8322 0 16.5352 2.30038 16.5352 5.23706C16.5352 8.34258 19.0972 10.3387 22.643 13.1013C23.2576 13.5801 23.893 14.0752 24.5667 14.6141C24.8395 14.8323 25.1698 14.9415 25.5 14.9415C25.8302 14.9415 26.1605 14.8323 26.4333 14.6141C27.107 14.0752 27.7424 13.5801 28.357 13.1013C31.9029 10.3387 34.4648 8.34258 34.4648 5.23706C34.4648 2.30038 32.1678 0 29.2354 0Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.0803163 27.662C0.232021 28.1026 0.579359 28.4485 1.02143 28.5943L17.6062 33.5903C18.24 33.8037 18.9462 33.5662 19.3222 33.0023L23.5799 26.6143C23.8382 26.2262 23.9009 25.7403 23.7506 25.301C23.5989 24.8603 23.2515 24.5145 22.8095 24.3687L6.22472 19.3727C5.58413 19.1552 4.88378 19.3975 4.50875 19.9607L0.251047 26.3487C-0.0072403 26.7369 -0.0699942 27.2228 0.0803163 27.662Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.9205 27.662C51.0708 27.2228 51.0081 26.7369 50.7498 26.3487L46.4921 19.9607C46.1171 19.3975 45.4167 19.1552 44.7761 19.3727L28.1913 24.3687C27.7493 24.5146 27.4019 24.8604 27.2502 25.301C27.0999 25.7402 27.1627 26.2261 27.421 26.6143L31.6787 33.0023C32.0546 33.5663 32.7608 33.8038 33.3946 33.5903L49.9794 28.5943C50.4215 28.4484 50.7687 28.1026 50.9205 27.662Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.006 31.3635L21.8085 34.66C20.6734 36.3575 18.5592 37.0639 16.6534 36.4226L5.97656 33.2182V43.15C5.97656 43.7935 6.38805 44.364 6.99796 44.5668L24.0059 50.2028V31.3635H24.006Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45.0234 43.1501V33.2183L34.2605 36.4504C32.5572 37.0293 30.3735 36.4274 29.193 34.663L26.9941 31.3635V50.203L44.002 44.567C44.612 44.3641 45.0234 43.7936 45.0234 43.1501Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.6019 13.5389C31.859 14.1606 31.0535 14.7885 30.1941 15.4581C29.5883 15.9301 28.9622 16.4178 28.3002 16.9474C27.5086 17.5807 26.5141 17.9295 25.5002 17.9295C24.4863 17.9295 23.4919 17.5807 22.7001 16.9473C22.0382 16.4179 19.1417 14.1606 18.3987 13.5389L8.29102 16.8786L23.6764 21.509C24.3815 21.7408 24.9985 22.1268 25.4971 22.6206C25.9869 22.1301 26.5859 21.7511 27.2542 21.5309L42.7061 16.8775L32.6019 13.5389Z",
    fill: "#004080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipateSvg);
export default __webpack_public_path__ + "static/media/ParticipateSvg.da92532acd5229f477ddc99b09943bb4.svg";
export { ForwardRef as ReactComponent };